{
  "version": 1,
  "asset_id": "3ba8e82a-233b-4bc3-af5c-8a3f0574a6a9",
  "project_id": "ab945133-766b-45c0-8595-d741bb5019f6",
  "url": "/__l5e/assets-v1/3ba8e82a-233b-4bc3-af5c-8a3f0574a6a9/william-cashin.png",
  "r2_key": "a/v1/ab945133-766b-45c0-8595-d741bb5019f6/3ba8e82a-233b-4bc3-af5c-8a3f0574a6a9/william-cashin.png",
  "original_filename": "william-cashin.png",
  "size": 17259,
  "content_type": "image/jpeg",
  "created_at": "2026-08-18T15:31:00Z"
}
